import React from 'react'

const TechnologyCard = ({ img, heading }) => {
  return (
      <div className='flex w-full lg:max-w-[415px] 800:max-w-[350px] md:max-w-[300px] max-w-[415px] flex-col items-center justify-center bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-[15px]  p-[3px] '>
          <div className='flex flex-col items-center justify-center gap-[16px] bg-black rounded-[15px] py-[24px] px-[15px] w-full h-full'>
              <img src={img} alt="React Icon" className='md:h-[60px] xs:h-[40px]' />
              <p className='font-faustina font-regular lg:text-[32px] md:text-[24px] xs:text-[clamp(18px,3.2vw,24px)] text-white w-full text-center'>{heading}</p>
          </div>
    </div>
  )
}

export default TechnologyCard